<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{ aLang.c_create }} tour du lịch</span>
        <span v-if="mData.viewMode == 'update'">{{ aLang.c_update }} tour du lịch</span>
        <span v-if="mData.viewMode == 'detail'">{{ aLang.c_detail }} tour du lịch</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col md="4">
              <el-form-item label="Tên tour" prop="ten_tour">
                <el-input v-model="mData.dataForm.ten_tour" :disabled="mData.viewMode == 'detail'" clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Tên công ty" prop="cong_ty_lu_hanh.ten.vi">
                <el-input v-model="mData.dataForm.cong_ty_lu_hanh.ten.vi" disabled clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Địa chỉ" prop="cong_ty_lu_hanh.dia_chi.dia_chi">
                <el-input v-model="mData.dataForm.cong_ty_lu_hanh.dia_chi.dia_chi" disabled clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Email" prop="cong_ty_lu_hanh.email">
                <el-input v-model="mData.dataForm.cong_ty_lu_hanh.email" disabled clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Điện thoại" prop="cong_ty_lu_hanh.dien_thoai">
                <el-input v-model="mData.dataForm.cong_ty_lu_hanh.dien_thoai" disabled clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Website" prop="cong_ty_lu_hanh.website">
                <el-input v-model="mData.dataForm.cong_ty_lu_hanh.website" disabled clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Địa điểm bắt đầu" prop="hanh_trinh.dia_diem_bat_dau">
                <el-select v-model="mData.dataForm.hanh_trinh.dia_diem_bat_dau" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listProvince" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Địa điểm kết thúc" prop="hanh_trinh.dia_diem_ket_thuc">
                <el-select v-model="mData.dataForm.hanh_trinh.dia_diem_ket_thuc" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listProvince" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Ngôn ngữ" prop="ngon_ngu">
                <el-select v-model="mData.dataForm.ngon_ngu" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listNgonNgu" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3" v-if="mData.viewMode == 'detail' || mData.viewMode == 'update'">
              <el-form-item label="Hiển thị" prop="visible">
                <el-select v-model="mData.dataForm.visible" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listHienThi" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <el-form-item label="Loại hình ưu đãi" prop="loai_hinh_uu_dai">
                <el-select v-model="mData.dataForm.loai_hinh_uu_dai" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable
                  @change="fn_selectTypeEndow(mData.dataForm.loai_hinh_uu_dai)">
                  <el-option v-for="item in mData.dataDefault.listEndow" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3" v-if="showInputMoney">
              <el-form-item
                label="Giá trị ưu đãi VND"
                prop="gia_tri_uu_dai"
                :rules="rulesGiaTriUuDai"
              >
                <ElementUiMoney
                  :value="mData.dataForm.gia_tri_uu_dai"
                  placeholder="Nhập giá trị ưu đãi"
                  :disabled="mData.viewMode == 'detail'"
                  :clearable="true"
                  @input="handleInputGiaTriUuDai"
                />
              </el-form-item>
            </b-col>
            <b-col md="3" v-if="showInputPercent">
              <el-form-item
                label="Giá trị ưu đãi %"
                prop="gia_tri_uu_dai"
                :rules="rulesGiaTriUuDaiPercent"
              >
                <el-input
                  v-model="mData.dataForm.gia_tri_uu_dai"
                  placeholder="Nhập giá trị ưu đãi"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @input="handleInputGiaTriUuDai"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-card>
            <div slot="header">
              Link đặt dịch vụ
            </div>
            <b-row>
              <b-col md="4" lg="3" cols="12" v-for="(item, index) in mData.dataForm.thong_tin_chung.link_dich_vu"
                :key="index">
                <el-form-item :label="'Link ' + (item.ten ? item.ten : '')" prop="">
                  <el-input v-model="item.link" :disabled="mData.viewMode == 'detail'" @input="forceUpdateUI"
                    clearable></el-input>
                </el-form-item>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <div slot="header">
              Link liên kết mạng xã hội
            </div>
            <b-row>
              <b-col md="4" lg="3" cols="12" v-for="(item, index) in mData.dataForm.thong_tin_chung.link_mang_xa_hoi"
                :key="index">
                <el-form-item :label="'Link ' + (item.name ? item.name : '')"
                  :prop="`thong_tin_chung.link_mang_xa_hoi[${index}].link`">
                  <el-input v-model="item.link" :disabled="mData.viewMode == 'detail'" @input="forceUpdateUI"
                    clearable></el-input>
                </el-form-item>
              </b-col>
            </b-row>
          </b-card>
          <b-row>
            <b-col md="4" style="margin-bottom: 10px;">
              <el-form-item class="mb-3" label="Ảnh đại diện" prop="mediaId">
                <el-upload action :auto-upload="false" list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit" :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien" :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien" :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList" :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :close-on-click-modal="true" :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%" top="51px" title="Chi tiết">
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
            <b-col md="8">
              <b-row>
                <b-col>
                  <el-form-item class="mb-0" label="Địa chỉ trên bản đồ" prop="">
                    <mapbox-component :viewMode="mData.viewMode" @update="fn_getDataFromMapboxComponent"
                      :cordinatesValue="mData.mapDataObject.value" :prop-disabled="mData.viewMode == 'detail'"
                      v-if="mData.dataDefault.showMap" id="mapBox"></mapbox-component>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="12">
              <el-form-item label="Giới thiệu" prop="mo_ta">
                <!-- <CknoimgComponent
                  v-model="mData.dataForm.mo_ta"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'"
                  @blur="handleBlur('mo_ta')"
                ></CknoimgComponent> -->
                <el-input v-model="mData.dataForm.mo_ta" :disabled="mData.viewMode == 'detail'" @input="forceUpdateUI"
                  type="textarea" :rows="2" clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Mô tả" prop="chi_tiet">
                <CknoimgComponent v-model="mData.dataForm.chi_tiet"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'" @blur="handleBlur('chi_tiet')">
                </CknoimgComponent>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button type="info" plain @click="fn_submitForm('create')" v-ladda
              v-if="mData.viewMode == 'create'">{{ aLang.c_create }}</el-button>

            <el-button type="info" plain @click="fn_submitForm('update')" v-ladda
              v-if="mData.viewMode == 'update'">{{ aLang.c_update }}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import DataService from '@/service/DataService';
import MethodService from '../../../service/MethodService';
import TourDuLichModel from './TourDuLichModel';
import TourDuLichApi from '../../../moduleApi/TourDuLichApi';
import CongTyLuHanhApi from '@/moduleApi/CongTyLuHanhApi';
import TourDuLichChoDuyetApi from '@/moduleApi/TourDuLichChoDuyetApi';
import NenTangDichVuApi from '@/moduleApi/NenTangDichVuApi';
import ProvinceApi from '@/moduleApi/ProvinceApi';
import CknoimgComponent from "../../../component/CknoimgComponent";
import ExtensionService from '@/service/ExtensionService';
import MapboxComponent from "../../../component/MapboxComponent";
import ValidService from "@/service/ValidService";
import ElementUiMoney from '@/component/ElementUiMoney';
export default {
  components: {
    CknoimgComponent,
    MapboxComponent,
    ElementUiMoney
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      show: true,
      mData: {
        viewMode: "create",
        moduleName: "TourDuLich",
        dataDefault: {
          showMap: false,
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleList,
          tourTimeErrorMessage: false,
          listProvince: [],
          listEndow: DataService.endowList,
        },
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        dataForm: MethodService.copyObject(TourDuLichModel.dataForm),
        fileUploadOption: MethodService.copyObject(
          TourDuLichModel.dataFormOther.fileUploadOption
        ),
        validForm: TourDuLichModel.validForm,
        ifHavePermission: true,
        dataPropMapDiaDiem: {
          fn_addLatLng: this.fn_addLatLngDiaDiem,
          lat: "",
          lng: "",
          showMap: false,
          id: "MapDiaDiem",
        },
        mapDataObject: {
          value: [105.850176, 21.0287797],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
        urlName: []
      },
      showInputMoney: false,
      showInputPercent: false,
      rulesGiaTriUuDai: [ValidService.checkGiaTriUuDaiVND(1000)],
      rulesGiaTriUuDaiPercent: [ValidService.checkGiaTriUuDaiPercent(1, 100)],
    };
  },
  async mounted() {
    let tinh_thanh = await ProvinceApi.list({
      limit: 1000
    });
    if (tinh_thanh.result) {
      this.mData.dataDefault.listProvince = tinh_thanh.result.map(item => {
        return { value: item.id, label: item.name }
      });
    }
  },
  async created() {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-create"
    ) {
      this.mData.dataForm.thong_tin_chung.kinh_do = 105.850176;
      this.mData.dataForm.thong_tin_chung.vi_do = 21.0287797;
      this.mData.dataDefault.showMap = true;
      const congTyLuHanhRes = await CongTyLuHanhApi.list({
        filters: "nguoi_quan_ly_ids=" + this.mData.currentUser.id + "&$fields=id,ten,email,dien_thoai,website,dia_chi"
      });
      this.mData.dataForm.cong_ty_lu_hanh = congTyLuHanhRes.result[0];
      const nen_tang_dich_vu = await NenTangDichVuApi.list({
        filters: "dich_vu=Tour&hien_thi=true"
      });
      if (nen_tang_dich_vu.result) {
        for (const element of nen_tang_dich_vu.result) {
          element.link = "";
        }
      }
      this.mData.dataForm.thong_tin_chung.link_dich_vu = nen_tang_dich_vu.result;

    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-create-admin"
    ) {
      this.mData.viewMode = "create";
      this.mData.dataForm.thong_tin_chung.kinh_do = 105.850176;
      this.mData.dataForm.thong_tin_chung.vi_do = 21.0287797;
      this.mData.dataDefault.showMap = true;
      const congTyLuHanhRes = await CongTyLuHanhApi.findById(this.$router.currentRoute.params.id);
      this.mData.dataForm.cong_ty_lu_hanh = congTyLuHanhRes.result;
      const nen_tang_dich_vu = await NenTangDichVuApi.list({
        filters: "dich_vu=Tour&hien_thi=true"
      });
      if (nen_tang_dich_vu.result) {
        for (const element of nen_tang_dich_vu.result) {
          element.link = "";
        }
      }
      this.mData.dataForm.thong_tin_chung.link_dich_vu = nen_tang_dich_vu.result;
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
    // this.fn_showMap();
  },
  methods: {
    changeShowInput(data) {
      if (!data) return
      this.show = false
      if (parseInt(data) > 100) this.mData.dataForm.gia_tri_uu_dai = 100
      setTimeout(() => {
        this.show = true
      }, 10)
    },
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (this.mData.dataDefault.tourTimeErrorMessage) {
          window.toastr.warning(this.mData.dataDefault.tourTimeErrorMessage);
          this.$refs["startDate"].focus();
          document.body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
          MethodService.stopLadda();
          return false;
        }
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          let uu_dai = null;
          if (this.mData.dataForm.loai_hinh_uu_dai) {
            uu_dai = this.mData.dataForm.gia_tri_uu_dai + this.mData.dataForm.loai_hinh_uu_dai;
          }
          if (type === "create") {
            if (this.mData.currentUser.roles.includes("Officer")) {
              data.duyet = {
                duoc_duyet: true
              };
              data.thong_tin_chung.kinh_do = this.mData.mapDataObject.value[0];
              data.thong_tin_chung.vi_do = this.mData.mapDataObject.value[1];
              data.cong_ty_lu_hanh_id = this.$router.currentRoute.params.id;
              data.uu_dai = uu_dai;
              await TourDuLichApi.create(data);
              this.fn_go();
              this.fn_resetForm();
            } else if (this.mData.currentUser.roles.includes("TourAgent")) {
              delete data.cong_ty_lu_hanh;
              data.duyet = {};
              data.thong_tin_chung.kinh_do = this.mData.mapDataObject.value[0];
              data.thong_tin_chung.vi_do = this.mData.mapDataObject.value[1];
              data.uu_dai = uu_dai;
              try {
                let idPost = await TourDuLichChoDuyetApi.create(data);
                if (idPost) {
                  this.$router.push({
                    name: "Admin-" + this.mData.moduleName + "-update-history",
                    params: { id: idPost.result },
                  });
                }
              } catch (error) {
                console.info(error);
              }
              this.fn_resetForm();
            }
          }
          if (type === "update") {
            if (
              this.mData.currentUser.roles.includes('Officer') ||
              this.mData.currentUser.roles.includes('Admin')
            ) {
              data.thong_tin_chung.kinh_do = this.mData.mapDataObject.value[0];
              data.thong_tin_chung.vi_do = this.mData.mapDataObject.value[1];
              data.id = this.$router.currentRoute.params.id;
              data.uu_dai = uu_dai;
              data.duyet = {};
              await TourDuLichApi.update(data);
              this.fn_go();
            } else if (
              this.mData.currentUser.roles.includes('TourAgent')
            ) {
              let tourChoDuyetRes = await TourDuLichChoDuyetApi.list({
                filters: "duoc_duyet_id=" + this.$router.currentRoute.params.id
              })
              if (tourChoDuyetRes.result.length == 0) {
                delete data.cong_ty_lu_hanh;
                data.thong_tin_chung.kinh_do = this.mData.mapDataObject.value[0];
                data.thong_tin_chung.vi_do = this.mData.mapDataObject.value[1];
                data.duoc_duyet_id = this.$router.currentRoute.params.id;
                data.uu_dai = uu_dai;
                data.ready = false;
                data.duyet = {
                  duoc_duyet: null
                };
                await TourDuLichChoDuyetApi.createUpdate(data);
                this.fn_go();
                this.fn_resetForm();
              } else if (tourChoDuyetRes.result.length > 0) {
                data.id = tourChoDuyetRes.result[0].id;
                data.ready = false;
                data.duyet = {
                  duoc_duyet: null
                };
                data.uu_dai = uu_dai;
                data.duoc_duyet_id = this.$router.currentRoute.params.id;
                await TourDuLichChoDuyetApi.tourAgentupdate(data);
                this.fn_go();
              }
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        TourDuLichModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      TourDuLichApi.clearCache();
      let tour = await TourDuLichApi.findById(id);
      if (tour.result) {
        let resCongTyLuHanh = await CongTyLuHanhApi.list({
          filters: "id=" + tour.result.cong_ty_lu_hanh_id + "&$fields=id,ten,email,dien_thoai,website,dia_chi"
        });
        this.mData.dataForm = tour.result;
        let loaiHinhUuDai = undefined;
        let giaTriUuDai = "";
        if (tour.result.uu_dai) {
          loaiHinhUuDai = tour.result.uu_dai.substr(tour.result.uu_dai.length - 1);
          giaTriUuDai = tour.result.uu_dai.substr(0, tour.result.uu_dai.length - 1);
          if (loaiHinhUuDai == "K") {
            this.showInputMoney = true;
            this.showInputPercent = false;
          } else if (loaiHinhUuDai == "%") {
            this.showInputMoney = false;
            this.showInputPercent = true;
          }
        }
        this.$set(this.mData.dataForm, "loai_hinh_uu_dai", loaiHinhUuDai);
        this.$set(this.mData.dataForm, "gia_tri_uu_dai", giaTriUuDai);
        this.mData.dataForm.cong_ty_lu_hanh = resCongTyLuHanh.result[0];

        let nen_tang_dich_vu = await NenTangDichVuApi.list({
          filters: "dich_vu=Tour&hien_thi=true"
        });
        if (nen_tang_dich_vu.result) {
          for (const element of nen_tang_dich_vu.result) {
            if (
              tour.result.thong_tin_chung.link_dich_vu &&
              tour.result.thong_tin_chung.link_dich_vu.find(x => x.id == element.id)
            ) {
              element.link = tour.result.thong_tin_chung.link_dich_vu.find(x => x.id == element.id).link;
            } else {
              element.link = "";
            }
          }
        }
        this.mData.dataForm.thong_tin_chung.link_dich_vu = nen_tang_dich_vu.result;

        if (tour.result.mediaId) {
          let data = {
            id: tour.result.mediaId,
            name: tour.result.mediaId,
            url: ExtensionService.urlImg + tour.result.mediaId
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }
        if (tour.result.thong_tin_chung.kinh_do == undefined ||
          tour.result.thong_tin_chung.vi_do == undefined
        ) {
          this.mData.dataForm.thong_tin_chung.kinh_do = 105.850176;
          this.mData.dataForm.thong_tin_chung.vi_do = 21.0287797;
        }
        this.mData.dataPropMapDiaDiem.lat = this.mData.dataForm.thong_tin_chung.vi_do;
        this.mData.dataPropMapDiaDiem.lng = this.mData.dataForm.thong_tin_chung.kinh_do;
        this.mData.dataPropMapDiaDiem.showMap = true;
        let coordinate = [
          this.mData.dataForm.thong_tin_chung.kinh_do,
          this.mData.dataForm.thong_tin_chung.vi_do
        ];
        this.mData.mapDataObject.value = coordinate;
        this.mData.mapDataObject.geoJson.type = "Point";
        this.mData.mapDataObject.geoJson.coordinates = coordinate;
        this.mData.dataDefault.showMap = true;
        this.mData.dataForm.thong_tin_chung.link_dich_vu = tour.result.thong_tin_chung.link_dich_vu;
      }
    },
    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return resData;
    },

    fn_selectTypeEndow(e) {
      if (e == "K") {
        this.showInputMoney = true;
        this.showInputPercent = false;
      } else if (e == "%") {
        this.showInputMoney = false;
        this.showInputPercent = true;
      } else {
        this.showInputMoney = false;
        this.showInputPercent = false;
      }
      this.$set(this.mData.dataForm, "gia_tri_uu_dai", "");
      this.$nextTick(() => {
        if (this.$refs["myForm"]) {
          this.$refs["myForm"].clearValidate("gia_tri_uu_dai");
        }
      });
    },

    fn_go() {
      this.$router.go(-1);
    },

    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.mediaId = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField('mediaId');
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "Tour")
        .then(res => {
          this.mData.dataForm.mediaId = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField('mediaId');
        })
        .catch(() => {
          this.$refs["myForm"].validateField('mediaId');
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_getDataFromMapboxComponent(value) {
      this.mData.mapDataObject = value;
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    },
    handleInputGiaTriUuDai(val) {
      this.$set(this.mData.dataForm, "gia_tri_uu_dai", val);
      if (this.$refs["myForm"]) {
        this.$refs["myForm"].clearValidate("gia_tri_uu_dai");
      }
      this.forceUpdateUI();
    },
    forceUpdateUI() {
      this.$forceUpdate();
    }
  }
}
</script>

<style>
p {
  margin-bottom: 0;
}

@media (min-width: 1220px) {
  .col-custom {
    max-width: 20%;
  }
}
</style>
